import { render, staticRenderFns } from "./cTemplateExportFormatRow.vue?vue&type=template&id=2454c19c&scoped=true"
import script from "./cTemplateExportFormatRow.vue?vue&type=script&lang=js"
export * from "./cTemplateExportFormatRow.vue?vue&type=script&lang=js"
import style0 from "./cTemplateExportFormatRow.vue?vue&type=style&index=0&id=2454c19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454c19c",
  null
  
)

export default component.exports